export default (show) => ({
  open: false,
  id: '',
  show: show,
  empty: false,
  container: document.querySelector('#join-our-team-roles'),
  filter() {
    if (this.$el.value !== this.id) {
      this.id = this.$el.value;
      fetch(ajax_object.ajaxurl + '?action=join_our_team', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: this.$el.value, show: this.show }),
      })
        .then((response) => response.json())
        .then((json) => {
          this.container.innerHTML = '';
          if (json.content) {
            this.empty = false;
            [...json.content].forEach((v, i, a) => {
              this.container.insertAdjacentHTML('beforeend', v);
            });
          } else {
            this.empty = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  },
});
